import { useSelector } from "react-redux";
import { selectFarms, selectFields } from "@agricircle/shared/farms/redux";
import { InitialFarmSetup } from "@agricircle/shared/farms/components";
import PastureMonitoring from "./pasture";
import FarmEdit from "./FarmEdit";
import { selectMode } from "../redux/pasture/selectors";


export default () => {
    const mode = useSelector(selectMode);
    const farms = useSelector(selectFarms);
    const fields = useSelector(selectFields);

    if (farms == null) return null;

    if (farms.length == 0) return <InitialFarmSetup />;

    if (fields == null) return null;

    return mode === "edit" ? <FarmEdit /> : <PastureMonitoring />;
};
